import { apiContextFetch, type ApiContext } from "@/hooks/api/base"

export function organizationFetch<T>(
  context: ApiContext,
  organizationId: string,
  route: string,
  options?: RequestInit
) {
  return apiContextFetch<T>(
    context,
    organizationId ? `organizations/${organizationId}/${route}` : `company/${route}`,
    options
  )
}
